module.exports = __webpack_public_path__ + "static/media/galerija_2022_0029.b0b7331f.jpg";